import React from 'react'
import clsx from 'clsx'
import { Box, Box as IconBox } from '@node-space/ui-components'
import { CSATIcon } from './CSATIcon'
import {
  CSATFeedbackValue,
  CSATFeedbackValueType,
  CSATOptionStatus,
  CSATOptionStatusType,
} from './types'

type CSATOptionProps = {
  label: string
  value: CSATFeedbackValueType
  status: CSATOptionStatusType
  onClick: () => void
}

export const CSATOption = ({ label, value, status, onClick }: CSATOptionProps) => {
  const isStatusSelected = status === CSATOptionStatus.SELECTED
  const isStatusUnselected = status === CSATOptionStatus.UNSELECTED
  const isStatusDefault = status === CSATOptionStatus.DEFAULT
  const isFeedbackValueBad = value === CSATFeedbackValue.BAD
  const isFeedbackValueOkay = value === CSATFeedbackValue.OKAY
  const isFeedbackValueGood = value === CSATFeedbackValue.GOOD

  const colorClass =
    isStatusUnselected || isStatusDefault
      ? 'text-forground-faint'
      : {
          'text-foreground-status-error': isFeedbackValueBad,
          'text-foreground-feature': isFeedbackValueOkay,
          'text-forground-status-success': isFeedbackValueGood,
        }

  return (
    <Box tag="button" flexCol centerChildren onClick={onClick} key={value}>
      <IconBox className={clsx(colorClass)}>
        <CSATIcon name={value} selected={isStatusSelected} />
      </IconBox>
      <span className={clsx('text-sm', isStatusSelected && 'font-semibold', colorClass)}>
        {label}
      </span>
    </Box>
  )
}
